import React, { useEffect, useState } from 'react';
import './App.css'; // Make sure to import your CSS styles

const AddStakeholderModal = ({ visible, onClose, workspaceId, onStakeholderAdded, initialStakeholder, workspaceName }) => {
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [number, setNumber] = useState('');
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState('');
  const [reportsTo, setReportsTo] = useState('');
  const [token, setToken] = useState(null);

  // Populate form with existing stakeholder data if editing
  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (initialStakeholder) {
      setName(initialStakeholder.name);
      setDesignation(initialStakeholder.designation);
      setNumber(initialStakeholder.number);
      setEmail(initialStakeholder.email);
      setDepartment(initialStakeholder.department);
      setReportsTo(initialStakeholder.reports_to);
    } else {
      // Reset the form if creating a new stakeholder
      setName('');
      setDesignation('');
      setNumber('');
      setEmail('');
      setDepartment('');
      setReportsTo('');
    }
  }, [initialStakeholder]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!name) {
      alert('Name is required fields!');
      return;
    }

    const stakeholderData = {
      name,
      designation,
      number,
      email,
      department,
      reports_to: reportsTo,
      workspace_id: workspaceId,
    };

    try {
      let response;
      if (initialStakeholder) {
        console.log(initialStakeholder);
        
        // If editing, send PUT request
        response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/stakeholder/update/${initialStakeholder.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(stakeholderData),
        });
      } else {
        // If creating new stakeholder, send POST request
        response = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/stakeholder/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(stakeholderData),
        });
      }

      if (response.ok) {
        const data = await response.json();
        onStakeholderAdded({ ...stakeholderData, id: initialStakeholder ? initialStakeholder.id : data.id }); // Add the new stakeholder ID if creating
        onClose(); // Close modal after adding/updating stakeholder
      } else {
        console.error('Failed to save stakeholder');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  if (!visible) {
    return null; // Don't render the modal if it's not visible
  }

  return (
    <div className="stakeholder-modal-overlay">
      <div className="stakeholder-modal-content">
        <div className="stakeholder-modal-header">
          <h2>{initialStakeholder ? 'Edit Stakeholder' : 'Add Stakeholder'} for Workspace: {workspaceName}</h2>
          <button className="stakeholder-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="stakeholder-modal-body" onSubmit={handleSubmit}>
          <div className="stakeholder-form-row">
            <label>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="stakeholder-form-row">
            <label>Designation</label>
            <select
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            >
              <option value="">Select Designation</option>
              <option value="Tax">Tax</option>
              <option value="Travel">Travel</option>
              <option value="Management">Management</option>
              <option value="Procurement">Procurement</option>
              <option value="Finance">Finance</option>
              <option value="others">others</option>
            </select>
          </div>
          <div className="stakeholder-form-row">
            <label>Phone Number</label>
            <input
              type="text"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
            />
          </div>
          <div className="stakeholder-form-row">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="stakeholder-form-row">
            <label>Department</label>
            <select
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
            >
              <option value="">Select Department</option>
              <option value="Tax">Tax</option>
              <option value="Travel">Travel</option>
              <option value="Management">Management</option>
              <option value="Finance">Finance</option>
              <option value="others">others</option>
            </select>
          </div>
          <div className="stakeholder-form-row">
            <label>Reports To</label>
            <input
              type="text"
              value={reportsTo}
              onChange={(e) => setReportsTo(e.target.value)}
            />
          </div>
          <button type="submit">{initialStakeholder ? 'Update' : 'Create'}</button>
        </form>
      </div>
    </div>
  );
};

export default AddStakeholderModal;
